"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventDraggableSegment = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = require("react");
var react_dnd_1 = require("react-dnd");
var react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
var constants_1 = require("./constants");
var DRAGGABLE_SEGMENT_STYLE = "flex flex-grow border-2 border-transparent hover:border-lochivar-default cursor-pointer";
var DRAGGING_STYLE = "pointer-events-auto";
var EventDraggableSegment = function (_a) {
    var type = _a.type, uuid = _a.uuid, calendarId = _a.calendarId, className = _a.className, endDrag = _a.endDrag, beginDrag = _a.beginDrag, offset = _a.offset;
    var _b = (0, react_1.useState)(false), dragging = _b[0], setDragging = _b[1];
    var _c = (0, react_dnd_1.useDrag)(function () { return ({
        type: type,
        item: function () {
            beginDrag(uuid, calendarId, offset);
            setDragging(true);
            return { uuid: uuid, calendarId: calendarId, type: type, offset: offset };
        },
        end: function () {
            endDrag(uuid, calendarId, offset);
            setDragging(false);
        },
    }); }, [uuid, calendarId, type, offset]), _ = _c[0], drag = _c[1], preview = _c[2];
    (0, react_1.useEffect)(function () {
        preview((0, react_dnd_html5_backend_1.getEmptyImage)(), { captureDraggingState: true });
    }, [preview]);
    return ((0, jsx_runtime_1.jsx)("div", { ref: drag, className: (0, clsx_1.default)(DRAGGABLE_SEGMENT_STYLE, dragging && DRAGGING_STYLE, className), style: {
            width: constants_1.SEGMENT_LENGTH,
            flexBasis: constants_1.SEGMENT_LENGTH,
        } }, void 0));
};
exports.EventDraggableSegment = EventDraggableSegment;
